module.exports = __webpack_public_path__ + "static/img/11.2d78128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/11.png
// module id = /0AQ
// module chunks = 35